import { useQuery } from "@tanstack/react-query";
import {
	getRollDetail,
	getRollNames,
	getRollTurns,
} from "../repositories/RollTurnHistoryDetailRepository";

export const useRollNames = () =>
	useQuery({
		queryKey: ["rollTurnHistoryRollNames"],
		queryFn: ({ signal }) => getRollNames(signal),
		staleTime: Number.POSITIVE_INFINITY,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});

export const useRollDetail = (rollName: string | null) =>
	useQuery({
		queryKey: ["rollTurnHistoryDetail", rollName],
		queryFn: ({ signal }) => getRollDetail(rollName as string, signal),
		enabled: !!rollName,
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});

export const useRollTurns = (rollName: string | null) =>
	useQuery({
		queryKey: ["rollTurnHistoryTurns", rollName],
		queryFn: ({ signal }) => getRollTurns(rollName as string, signal),
		enabled: !!rollName,
		retry: false,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
